function getCountryBySelector() {
//   const hiddenInput = document.getElementById("CurrencySelector-header");
//   return hiddenInput.value;
} // Get country from end user selected

// // Function to get the price based on the country code
const getCountryPriceByCode = (country) => {
//   const Rates = {
//     EUR: { rate: 0.35, currency: "EUR" },
//     USD: { rate: 0.31, currency: "USD" },
//     UK: { rate: 0.41, currency: "GBP" },
//   };

//   const countriesRate = {
//     FR: Rates.EUR,
//     IT: Rates.EUR,
//     AT: Rates.EUR,
//     BE: Rates.EUR,
//     CZ: Rates.EUR,
//     DK: Rates.EUR,
//     FI: Rates.EUR,
//     DE: Rates.EUR,
//     IE: Rates.EUR,
//     NL: Rates.EUR,
//     PL: Rates.EUR,
//     PT: Rates.EUR,
//     ES: Rates.EUR,
//     SE: Rates.EUR,
//     CH: Rates.USD,
//     NZ: Rates.USD,
//     JO: Rates.USD,
//     NO: Rates.USD,
//     AU: Rates.USD,
//     AF: Rates.USD,
//     AX: Rates.USD,
//     AL: Rates.USD,
//     DZ: Rates.USD,
//     AD: Rates.USD,
//     AO: Rates.USD,
//     AI: Rates.USD,
//     AG: Rates.USD,
//     AR: Rates.USD,
//     AM: Rates.USD,
//     AW: Rates.USD,
//     AC: Rates.USD,
//     AZ: Rates.USD,
//     BS: Rates.USD,
//     BH: Rates.USD,
//     BD: Rates.USD,
//     BB: Rates.USD,
//     BY: Rates.USD,
//     BZ: Rates.USD,
//     BJ: Rates.USD,
//     BM: Rates.USD,
//     BT: Rates.USD,
//     BO: Rates.USD,
//     BA: Rates.USD,
//     BW: Rates.USD,
//     BR: Rates.USD,
//     IO: Rates.USD,
//     VG: Rates.USD,
//     BN: Rates.USD,
//     BG: Rates.EUR,
//     BF: Rates.USD,
//     BI: Rates.USD,
//     KH: Rates.USD,
//     CM: Rates.USD,
//     CA: Rates.USD,
//     CV: Rates.USD,
//     BQ: Rates.USD,
//     KY: Rates.USD,
//     CF: Rates.USD,
//     TD: Rates.USD,
//     CL: Rates.USD,
//     CN: Rates.USD,
//     CX: Rates.USD,
//     CC: Rates.USD,
//     CO: Rates.USD,
//     KM: Rates.USD,
//     CG: Rates.USD,
//     CD: Rates.USD,
//     CK: Rates.USD,
//     CR: Rates.USD,
//     CI: Rates.USD,
//     HR: Rates.EUR,
//     CW: Rates.USD,
//     CY: Rates.EUR, 
//     DJ: Rates.USD,
//     DM: Rates.USD,
//     DO: Rates.USD,
//     EC: Rates.USD,
//     EG: Rates.USD,
//     SV: Rates.USD,
//     GQ: Rates.USD,
//     ER: Rates.USD,
//     EE: Rates.EUR, 
//     SZ: Rates.USD,
//     ET: Rates.USD,
//     FK: Rates.USD,
//     FO: Rates.USD,
//     FJ: Rates.USD,
//     GF: Rates.USD,
//     PF: Rates.USD,
//     TF: Rates.USD,
//     GA: Rates.USD,
//     GM: Rates.USD,
//     GE: Rates.USD,
//     GH: Rates.USD,
//     GI: Rates.USD,
//     GR: Rates.EUR, 
//     GL: Rates.USD,
//     GD: Rates.USD,
//     GP: Rates.USD,
//     GT: Rates.USD,
//     GG: Rates.USD,
//     GN: Rates.USD,
//     GW: Rates.USD,
//     GY: Rates.USD,
//     HT: Rates.USD,
//     HN: Rates.USD,
//     HK: Rates.USD,
//     HU: Rates.EUR,
//     IS: Rates.USD,
//     IN: Rates.USD,
//     ID: Rates.USD,
//     IQ: Rates.USD,
//     IM: Rates.USD,
//     IL: Rates.USD,
//     IT: Rates.EUR, 
//     JM: Rates.USD,
//     JP: Rates.USD,
//     JE: Rates.USD,
//     KZ: Rates.USD,
//     KE: Rates.USD,
//     KI: Rates.USD,
//     XK: Rates.USD,
//     KW: Rates.USD,
//     KG: Rates.USD,
//     LA: Rates.USD,
//     LV: Rates.EUR, 
//     LB: Rates.USD,
//     LS: Rates.USD,
//     LR: Rates.USD,
//     LY: Rates.USD,
//     LI: Rates.USD,
//     LT: Rates.EUR,
//     LU: Rates.EUR,
//     MO: Rates.USD,
//     MG: Rates.USD,
//     MW: Rates.USD,
//     MY: Rates.USD,
//     MV: Rates.USD,
//     ML: Rates.USD,
//     MT: Rates.EUR,
//     MQ: Rates.USD,
//     MR: Rates.USD,
//     MU: Rates.USD,
//     YT: Rates.USD,
//     MX: Rates.USD,
//     MD: Rates.USD,
//     MC: Rates.USD,
//     MN: Rates.USD,
//     ME: Rates.USD,
//     MS: Rates.USD,
//     MA: Rates.USD,
//     MZ: Rates.USD,
//     MM: Rates.USD,
//     NA: Rates.USD,
//     NR: Rates.USD,
//     NP: Rates.USD,
//     NC: Rates.USD,
//     NI: Rates.USD,
//     NE: Rates.USD,
//     NG: Rates.USD,
//     NU: Rates.USD,
//     NF: Rates.USD,
//     MK: Rates.USD,
//     OM: Rates.USD,
//     PK: Rates.USD,
//     PS: Rates.USD,
//     PA: Rates.USD,
//     PG: Rates.USD,
//     PY: Rates.USD,
//     PE: Rates.USD,
//     PH: Rates.USD,
//     PN: Rates.USD,
//     QA: Rates.USD,
//     RE: Rates.USD,
//     RO: Rates.EUR,
//     RU: Rates.USD,
//     RW: Rates.USD,
//     WS: Rates.USD,
//     SM: Rates.USD,
//     ST: Rates.USD,
//     SA: Rates.USD,
//     SN: Rates.USD,
//     RS: Rates.USD,
//     SC: Rates.USD,
//     SL: Rates.USD,
//     SG: Rates.USD,
//     SX: Rates.USD,
//     SK: Rates.EUR, 
//     SI: Rates.EUR,
//     SB: Rates.USD,
//     SO: Rates.USD,
//     ZA: Rates.USD,
//     GS: Rates.USD,
//     KR: Rates.USD,
//     SS: Rates.USD,
//     LK: Rates.USD,
//     BL: Rates.USD,
//     SH: Rates.USD,
//     KN: Rates.USD,
//     LC: Rates.USD,
//     MF: Rates.USD,
//     PM: Rates.USD,
//     VC: Rates.USD,
//     SD: Rates.USD,
//     SR: Rates.USD,
//     SJ: Rates.USD,
//     TW: Rates.USD,
//     TJ: Rates.USD,
//     TZ: Rates.USD,
//     TH: Rates.USD,
//     TL: Rates.USD,
//     TG: Rates.USD,
//     TK: Rates.USD,
//     TO: Rates.USD,
//     TT: Rates.USD,
//     TA: Rates.USD,
//     TN: Rates.USD,
//     TR: Rates.USD,
//     TM: Rates.USD,
//     TC: Rates.USD,
//     TV: Rates.USD,
//     UM: Rates.USD,
//     UG: Rates.USD,
//     UA: Rates.USD,
//     AE: Rates.USD,
//     US: Rates.USD,
//     UY: Rates.USD,
//     UZ: Rates.USD,
//     VU: Rates.USD,
//     VA: Rates.USD,
//     VE: Rates.USD,
//     VN: Rates.USD,
//     WF: Rates.USD,
//     EH: Rates.USD,
//     YE: Rates.USD,
//     ZM: Rates.USD,
//     ZW: Rates.USD,
//     US: Rates.USD,
//     GB: Rates.UK,
//     BH: { rate: 0.81, currency: "BHD" },
//     KW: { rate: 1, currency: "KWD" },
//     OM: { rate: 0.8, currency: "OMR" },
//     QA: { rate: 0.084, currency: "QAR" },
//     SA: { rate: 0.082, currency: "SAR" },
//     AE: { rate: 0.083, currency: "AED" },
//     default: { rate: 1, currency: "KWD" },
//   };
//   return countriesRate?.[country] ?? countriesRate["default"];
};

// const getConvertCurrencyByCountryRate = (amount, rate) => amount / rate; // Convert currency by country rate point
// const getRoundByConvertedAmount = (amount) => Math.round(amount); // Rounding the amount

// // Ignore rounding the amount
// const isIgnoringCountriesForRound = ['KW'];

// // Convert Currency function
// const convertCurrencyByCountry = async (product, document) => {
//   const country = getCountryBySelector(document);
//   const amountInKWD = product.price / 100;
//   const conversionRate = getCountryPriceByCode(country);
//   const amountInCountry = getConvertCurrencyByCountryRate(
//     amountInKWD,
//     conversionRate.rate
//   );
  
//   const finalAmount = isIgnoringCountriesForRound.includes(country) ? amountInCountry : getRoundByConvertedAmount(amountInCountry);
//   const displayAmount = `${finalAmount} ${conversionRate.currency}`;
//   return displayAmount;
// };

// // Add to bag function
// const addProductToBag = (document, productJson, id) => {
//   // Update the free shipping
//   updateFreeShippingCountryBased();
//   const addBagTotalPriceSpan = document.getElementById(id);
//   if (addBagTotalPriceSpan) {
//     var totalPriceText = addBagTotalPriceSpan.textContent.match(/\d+\.\d+/);
//     if (!totalPriceText?.length) return addBagTotalPriceSpan.textContent;
//     const country = getCountryBySelector();
//     const addBagAmountInKWD = +totalPriceText[0];
//     const addBagConversionRate = getCountryPriceByCode(country);
//     const addBagAmountInCountry = getConvertCurrencyByCountryRate(
//       addBagAmountInKWD,
//       addBagConversionRate.rate
//     );
//     const addBagFinalAmount = getRoundByConvertedAmount(addBagAmountInCountry);
//     const addBagDisplayAmount = `${addBagFinalAmount} ${addBagConversionRate.currency}`;
//     if (addBagTotalPriceSpan)
//       addBagTotalPriceSpan.innerHTML = addBagDisplayAmount;
//   }
// };

// const updateQuickSearchCurrency = (quickSearchDocument) => {
//   if (quickSearchDocument && quickSearchDocument?.textContent) {
//     var totalPriceText = quickSearchDocument.textContent.match(/\d+\.\d+/);
//     console.log('totalPriceText', totalPriceText);
//     if (!totalPriceText?.length) return quickSearchDocument.textContent;
//     const country = getCountryBySelector();
//     const quickSearchAmountInKWD = +totalPriceText[0];
//     const quickSearchConversionRate = getCountryPriceByCode(country);
//     const quickSearchAmountInCountry = getConvertCurrencyByCountryRate(
//       quickSearchAmountInKWD,
//       quickSearchConversionRate.rate
//     );
//     const quickSearchFinalAmount = getRoundByConvertedAmount(
//       quickSearchAmountInCountry
//     );
//     const quickSearchDisplayAmount = `${quickSearchFinalAmount} ${quickSearchConversionRate.currency}`;
//     quickSearchDocument.innerHTML = quickSearchDisplayAmount;
//   }
// };

// const setQuickSearchCurrency = (document) => {
//   const wait = () => {
//     const documents = document.getElementsByClassName(
//       "quick-search__result-price"
//     );
//     for (
//       let documentIndex = 0;
//       documentIndex < documents?.length;
//       documentIndex++
//     ) {
//       updateQuickSearchCurrency(documents[documentIndex]);
//     }
//   };
//   setTimeout(wait, 2000);
// };

// const updateQuickProductCurrency = (product) => {
//   const wait = async () => {
//     const displayAmount = await convertCurrencyByCountry(product, document);
//     const almPrice = document.getElementById(`${product.id}-alm-sprice`);
//     if (almPrice) almPrice.innerHTML = displayAmount;
//   };
//   setTimeout(wait, 2000);
// };

// const gccCountries = ['bahrain', 'jordan', 'kuwait', 'oman', 'qatar', 'saudi arabia', 'uae'];
const updateFreeShippingCountryBased = (delay = false) => {
//   console.log('Calleedddd');
//   const wait = () => {
//     const freeShippingBars = document.getElementsByClassName('free-shipping-bar');
//     console.log(freeShippingBars)
//     const freeShippingLength = freeShippingBars?.length;
//     console.log(freeShippingLength)
//     // Get currently selected country
//       const selectedButton = document.querySelector('.disclosure__toggle--currency');
//       const label = selectedButton?.textContent.trim();
//       const countries = label.match(/^(.+?)\s*\(\s*(.+?)\s*\)$/);
//       console.log(countries?.length)
//       let threshold = "40";
      
//       if (countries?.length) {
//         const country = countries[1]; // "Bahrain"
//         const currency = countries[2]; // "BHD"
//         console.log('threshold');
//         console.log(threshold)
//        console.log(country?.toLowerCase());
//         if (gccCountries.includes(country?.toLowerCase())) threshold = "25";
//       }

//     console.log(threshold);
//     console.log(freeShippingBars);
    
    
//     // Set threshold on each free shipping bar
//     for (let index = 0; index < freeShippingLength; index++) {
//       const bar = freeShippingBars[index];
//       bar.setAttribute('data-threshold', threshold);
//       console.log('After', bar.getAttribute('data-threshold'));
//     }
//     return threshold;
//   }
  
//   if(delay) setTimeout(wait, 3000);
//   wait();
}

const updateFreeShippingAmount = (delay = false) => {
//   const wait = () => {
//     const freeShipElement = document.getElementsByClassName("fs-body-bold");
//     const elementLength = freeShipElement?.length;
//     for (let index = 0; index < elementLength; index++) {
//       const freeShip = freeShipElement[index];
//       updateQuickSearchCurrency(freeShip);
//     }
//   };
//   if (delay) setTimeout(wait, 3000);
//   wait();
};

// const updateAddBag = (product = undefined) => {
//   const wait = () => {
//     addProductToBag(document, product, `${product.id}-sale-price`);
//   };
//   setTimeout(wait, 3000);
// };

(()=>{
  const isNotInIframe=(window.self === window.top);
  if(!location.pathname.includes("/en-ae") && !location.pathname.includes("/ar-ae") && isNotInIframe){
    const addedPath=`${location.origin}/en-ae`
    window.location.href=addedPath;
  }
})()